var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updatePublishedForRun } from '../services/IIMRunsService';
export default function useUpdateIIMRunPublished({ inspectionId, iimRunId }) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ published }) => updatePublishedForRun(iimRunId, published),
        // Optimistic update
        onMutate: (variables) => __awaiter(this, void 0, void 0, function* () {
            // Cancel any outgoing refetches to avoid overwriting our optimistic update
            yield queryClient.cancelQueries({ queryKey: ['iim-last-run', inspectionId] });
            // Snapshot the previous value
            const previousData = queryClient.getQueryData(['iim-last-run', inspectionId]);
            // Optimistically update the cache
            if (previousData === null || previousData === void 0 ? void 0 : previousData.iimRun) {
                queryClient.setQueryData(['iim-last-run', inspectionId], Object.assign(Object.assign({}, previousData), { iimRun: Object.assign(Object.assign({}, previousData.iimRun), { published: variables.published }) }));
            }
            // Return the snapshot so we can rollback if something goes wrong
            return { previousIimRun: previousData };
        }),
        // If the mutation fails, use the context we returned above to roll back
        onError: (err, variables, context) => {
            if (context === null || context === void 0 ? void 0 : context.previousIimRun) {
                queryClient.setQueryData(['iim-last-run', inspectionId], context.previousIimRun);
            }
            console.error('Error updating IIM run published status:', err);
        },
        // Always refetch after error or success to ensure we have the correct data
        onSettled: (data) => {
            if (data) {
                void queryClient.invalidateQueries({ queryKey: ['iim-last-run', inspectionId] });
            }
        }
    });
}
